<template>
  <FriedAvatar v-if="deletedAt || missingParticipantData" thumb-url="" :size="size" />
  <FriedAvatar v-else :thumb-url="thumbUrl" :name="name" :size="size" />
</template>
<script lang="ts">
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import { AvatarSize } from '@getaccept/fried-tofu';

export default defineComponent({
  props: {
    name: {
      type: String,
      default: '',
    },
    thumbUrl: {
      type: String,
      default: '',
    },
    deletedAt: {
      type: Number,
      default: null,
    },
    size: {
      type: String as PropType<AvatarSize>,
      default: AvatarSize.Medium,
    },
  },
  setup(props) {
    const missingParticipantData = computed(() => !props.name && !props.thumbUrl);
    return {
      missingParticipantData,
    };
  },
});
</script>
